import { ResolveFn, Route } from '@angular/router';
import { KIDS_IMPORT_PATH, KIDS_IMPORT_TITLE } from '../../mgs-path-defs';
import { mgsKidsGuard } from '../../mgs-guards';
import { inject } from '@angular/core';
import { KidsImportService } from './kids-import.service';

const kidsDatenImportInfoResolver: ResolveFn<void> = async () => {
  const kidsDatenImportInfoService = inject(KidsImportService);
  await kidsDatenImportInfoService.kidsImportInfoErmitteln();
};

export const kidsImportRoute: Route = {
  path: KIDS_IMPORT_PATH,
  title: KIDS_IMPORT_TITLE,
  loadComponent: () => import('./kids-import.component'),
  canActivate: [mgsKidsGuard],
  resolve: { importInfo: kidsDatenImportInfoResolver }
};
